import { createFileRoute } from "@tanstack/react-router";
import { Flex } from "@radix-ui/themes";
import Footer from "@/components/nav/Footer";
import SmoothScroll from "@/components/ui/SmoothScroll";
import HeroSection from "@/components/fans/HeroSection";
import FeaturedAlbumsSection from "@/components/fans/FeaturedAlbumsSection";
import FeatureCardsSection from "@/components/fans/FeatureCardsSection";
import JoinLutelySection from "@/components/landing/JoinLutelySection";
import { seoHead, SITE_DESCRIPTION, SITE_TITLE } from "@/lib/seo";

export const Route = createFileRoute("/")({
  component: HomePage,
  head: () =>
    seoHead({
      title: SITE_TITLE,
      description: SITE_DESCRIPTION,
      canonicalPath: "/",
    }),
});

function HomePage() {
  return (
    <Flex direction="column" className="bg-[#fafbfd]">
      <SmoothScroll />
      <HeroSection />
      <FeaturedAlbumsSection />
      <FeatureCardsSection />
      <JoinLutelySection />
      <Footer />
    </Flex>
  );
}
